import React, { useState, useEffect, useContext } from "react";

import { useHistory } from "react-router-dom";
import { ContractFormModal } from "./ContractFormModal";
import { adminAPI, memberAPI } from "../../utility/axios";
import useAzureAuthentication from "../../hooks/useAzureAuthentication";
import { MemberApplicationContext } from "../../context/MemberApplicationContext";
import useAzureAuthenticationAdmin from "../../hooks/useAzureAuthenticationAdmin";
import { b64toBlob } from "../../helpers/ConversionHelpers";

const CreatePacketForm = (props) => {
  let { id, applicationType } = props;

  const [isEditMode, setIsEditMode] = useState(false);
  const [isPacketSubmitting, setisPacketSubmitting] = useState(false);
  const [isPreviewSubmitting, setIsPreviewSubmitting] = useState(false);
  const [isBlankSubmitting, setIsBlankSubmitting] = useState(false);
  const [hasContracts, setHasContacts] = useState(false);
  const [envelopePreviewRedirectURL, setEnvelopePreviewRedirectURL] =
    useState();

  const [hasExistingDocusignPreview, setHasExistingDocusignPreview] =
    useState(false);
  const memberApplication = useContext(MemberApplicationContext);
  const [envelopeId, setEnvolopeId] = useState(false);
  const [blankPacket, setBlankPacket] = useState(false);
  const [pollingInterval, setPollingInterval] = useState(null);
  let { authInfo } = useAzureAuthentication();
  let { authInfoAdmin } = useAzureAuthenticationAdmin();

  const history = useHistory();

  useEffect(() => {
    if (envelopePreviewRedirectURL)
      window.open(envelopePreviewRedirectURL, "_blank");
  }, [envelopePreviewRedirectURL]);

  useEffect(() => {
    if (memberApplication.service) {
    } else {
      memberApplication.onIDChange(id);
    }
    if(memberApplication.envelopeId)
     setEnvolopeId(memberApplication.envelopeId);
  }, [authInfo]);

  // Update envelopeId when memberApplication.envelopeId changes
  useEffect(() => {
    if(memberApplication.envelopeId) {
      setEnvolopeId(memberApplication.envelopeId);
    }
  }, [memberApplication.envelopeId]);

  // Start polling if docusignId exists but envelope is not ready yet
  useEffect(() => {
    if (memberApplication.docusignId && 
        (!envelopeId || envelopeId === "00000000-0000-0000-0000-000000000000") &&
        !pollingInterval) {
      console.log("DocusignId exists but no envelope yet. Starting polling...");
      startPollingForEnvelope();
    }
  }, [memberApplication.docusignId, envelopeId]);

  useEffect(() => {
    if (authInfoAdmin) {
      checkForExistingDocusignPreview();
    }
  }, [authInfoAdmin]);

  useEffect(() => {
    if (memberApplication.id) {
    }
  }, [memberApplication.id]);

  // Cleanup polling interval on unmount
  useEffect(() => {
    return () => {
      if (pollingInterval) {
        clearInterval(pollingInterval);
      }
    };
  }, [pollingInterval]);

  function routeChange(path) {
    if (path) {
      history.push(`${path ?? ""}/${id}`);
    }
  }

  function onBlankPacketChange(e) {

    if (e != undefined) {
      setBlankPacket(e.target.checked);
    }
  }
  async function checkForExistingDocusignPreview() {
    async function getHasExistingDocusignPreview() {
      const res = await adminAPI.get(
        "api/DocusignQueue/DoesApplicationPreviewExist",
        {
          params: {
            applicationId: id,
          },
          headers: { Authorization: `Bearer ${authInfoAdmin.userAccessToken}` },
        }
      );

      setHasExistingDocusignPreview(res.data);
    }

    await getHasExistingDocusignPreview();
  }
  function onBackClick(e) {
    e.preventDefault();
    let gpoRoute = memberApplication.workflow !== "LTC Network" ? "/AdditionalOutputInfo" : "/AdditionalInformation";
    return routeChange(gpoRoute);
    
   // routeChange("/AdditionalInformation");
  }

  function startPollingForEnvelope() {
    // Check if authInfo is available before starting polling
    if (!authInfo || !authInfo.userAccessToken) {
      console.log("AuthInfo not available yet. Skipping polling.");
      return;
    }
    
    console.log("Starting to poll for envelope...");
    let pollCount = 0;
    const maxPolls = 20; // Poll for max 60 seconds (20 * 3 seconds)
    
    const interval = setInterval(async () => {
      pollCount++;
      console.log(`Polling attempt ${pollCount}/${maxPolls}`);
      
      try {
        const res = await memberAPI.get("api/MemApp/FetchMemberAppEnvelopeId", {
          params: { id: id },
          headers: { Authorization: `Bearer ${authInfo.userAccessToken}` },
        });
        
        console.log("Polled EnvelopeId:", res.data.EnvelopeId);
        
        if (res.data.EnvelopeId && res.data.EnvelopeId !== "00000000-0000-0000-0000-000000000000") {
          console.log("Envelope created! Stopping poll.");
          setEnvolopeId(res.data.EnvelopeId);
          memberApplication.onEnvelopeIdChange(res.data.EnvelopeId);
          clearInterval(interval);
          setPollingInterval(null);
        } else if (pollCount >= maxPolls) {
          console.log("Max polling attempts reached. Stopping poll.");
          clearInterval(interval);
          setPollingInterval(null);
        }
      } catch (error) {
        console.error("Error polling for envelope:", error);
        clearInterval(interval);
        setPollingInterval(null);
      }
    }, 3000); // Poll every 3 seconds
    
    setPollingInterval(interval);
  }

  async function onSubmit(e) {
    async function GetDocusignQueueId() {
      const res = await adminAPI.post(
        "api/DocusignQueue/UpdateDocusignQueue",
        {
          DocusignQueue: {
            UpdateFor: "INSERT",
            MEMAPPID: id,
            SENDEMAIL: 1,
            QUEUEID: null,
            DOCSTATUS: "E",
            STATUS: "A",
            EMAILSUBJECT: "EmailTestSubject",
            EMAILBLURB: "EmailTestBlurb",
            USER: authInfo.userEmail,
            SERVICE: "0",
            ISPREVIEWTEMPLATE: false,
          },
        },
        {
          headers: { Authorization: `Bearer ${authInfoAdmin.userAccessToken}` },
        }
      );

      return res.data;
    }

    async function GetDocusignQueueAndPreviewDetails() {
      const res = await adminAPI.post(
        "api/DocusignQueue/DocusignQueuePreview",
        {
          DocusignQueue: {
            UpdateFor: "INSERT",
            MEMAPPID: id,
            SENDEMAIL: 1,
            QUEUEID: null,
            DOCSTATUS: "E",
            STATUS: "A",
            EMAILSUBJECT: "EmailTestSubject",
            EMAILBLURB: "EmailTestBlurb",
            USER: authInfo.userEmail,
            SERVICE: "0",
            ISPREVIEWTEMPLATE: true,
            PreviewReturnUrl: window.location.href,
            BLANKPACKET:blankPacket
          },
        },
        {
          headers: { Authorization: `Bearer ${authInfoAdmin.userAccessToken}` },
        }
      );

      return res.data;
    }

    async function SetApplicationDocusignQueueId(docusignQueueId) {
      console.log(docusignQueueId);
      const res = await memberAPI.post(
        "api/MemberForm/UpdateApplicationDocusignQueueId",
        {
          user: authInfo.userEmail,
          applicationId: id,
          docusignQueueId: docusignQueueId,
        },
        { headers: { Authorization: `Bearer ${authInfo.userAccessToken}` } }
      );
    }

    async function GetEnvopleId() {
      console.log(id);
      const res = await memberAPI.get("api/MemApp/FetchMemberAppEnvelopeId", {
        params: {
          id: id,
        },
        headers: { Authorization: `Bearer ${authInfo.userAccessToken}` },
      });
      setEnvolopeId(res.data.EnvelopeId);
    }

    async function SetApplicationDocusignPreviewQueueId(docusignQueueId) {
      console.log(docusignQueueId);
      const res = await memberAPI.post(
        "api/MemberForm/UpdateApplicationDocusignQueuePreviewId",
        {
          user: authInfo.userEmail,
          applicationId: id,
          docusignQueueId: docusignQueueId,
        },
        { headers: { Authorization: `Bearer ${authInfo.userAccessToken}` } }
      );
    }

    if (e.target.id == "send") {
      // Prevent multiple submissions
      if (memberApplication.docusignId) {
        console.log("Packet already submitted. DocusignId:", memberApplication.docusignId);
        return;
      }
      
      // This will return the QueueId and will call the packet generation to run in the background
      setisPacketSubmitting(true);
      try {
        //insert docusign queue, updates docusign queue in memapp, 
        // send envelope from envelope queue table
        // // sends envelope, save to envelope table, update docusignqueue for status
        let docusignQueueId = await GetDocusignQueueId();
        console.log("Created DocusignQueueId:", docusignQueueId);
        //updates docusign queue in memapp after sending envelope//depends on if request gets interrupted 
        await SetApplicationDocusignQueueId(docusignQueueId);
        //change docusign id on front end
        memberApplication.onDocusignIdChange(docusignQueueId);
        console.log("Updated memberApplication.docusignId to:", docusignQueueId);
        //get envelope from mem app 
        await GetEnvopleId();
        // Start polling for envelope creation
        startPollingForEnvelope();
      } catch (error) {
        console.error(error);
        alert(
          "An error has occured while generating the packet. If the error continues please contact IT."
        );
      }
      setisPacketSubmitting(false);
    } else if (e.target.id == "preview" || e.target.id == "preview-icon") {
      setIsPreviewSubmitting(true);

      try {
        let docusignQueueDetails = await GetDocusignQueueAndPreviewDetails();
        await SetApplicationDocusignPreviewQueueId(
          docusignQueueDetails.QueueId
        );
        setEnvelopePreviewRedirectURL(docusignQueueDetails.EnvelopePreviewUrl);
        setHasExistingDocusignPreview(true);
      } catch (error) {
        console.error(error);
        alert(
          "An error has occured while generating the packet. If the error continues please contact IT."
        );
      }

      setIsPreviewSubmitting(false);
    } else {
      // eslint-disable-next-line no-throw-literal
      throw `Invalid submit source of ${e.target.id} shoube be send or preview`;
    }
  }

  async function downloadBlankPacket(){
    async function fetchPacket (){
      let param = {
        MEMAPPID: id,
        
      }
      const res = await adminAPI.post("api/DocusignQueue/GetBlankPacket",{
        Args: JSON.stringify(param),
      },{
        headers: {Authorization: `Bearer ${authInfoAdmin.userAccessToken}`}
      });
      return res.data
    }
    setIsBlankSubmitting(true);
    const data = await fetchPacket();
    setIsBlankSubmitting(false);
    const blob = b64toBlob(data, "application/pdf");
    let url = URL.createObjectURL(blob);
    let tab = window.open();
    tab.location.href = url;
  }

  async function getPdf() {
    setisPacketSubmitting(true);
    async function fetchPdf() {
      let test = {
        ENVELOPEID: envelopeId,
        VIEWPACKET: true,
      };
      const res = await adminAPI.post(
        "api/Docusign/GetEnvelopePreviewDocument",
        {
          Args: JSON.stringify(test),
        },
        {
          headers: { Authorization: `Bearer ${authInfoAdmin.userAccessToken}` },
        }
      );

      return res.data;
    }

    const data = await fetchPdf();
    const blob = b64toBlob(data, "application/pdf");

    let url = URL.createObjectURL(blob);

    let tab = window.open();
    tab.location.href = url;

    setisPacketSubmitting(false);
    // If we want to directly download
    //let a = document.createElement("a");
    //a.style = "display: none";
    //document.body.appendChild(a);
    //a.href = url;
    // a.download = 'packet.pdf'; // gives it a name via an a tag
    //a.click();
    //window.URL.revokeObjectURL(url);
  }

  async function fetchExistingPreview() {
    async function getPreviousPreviewUrl() {
      const res = await adminAPI.get(
        "api/DocusignQueue/GetExistingEnvelopePreviewUrl",
        {
          params: {
            applicationId: id,
            returnUrl: window.location.href,
          },
          headers: { Authorization: `Bearer ${authInfoAdmin.userAccessToken}` },
        }
      );
      return res.data;
    }
    const url = await getPreviousPreviewUrl();
    setEnvelopePreviewRedirectURL(url);
  }
  return (
    <div>
      <br />
      <div className="mb-3 d-grid gap-4 d-md-flex justify-content-md-center">
        <button
          className="btn btn-primary"
          onClick={onBackClick}
          disabled={isPreviewSubmitting || isPacketSubmitting || isEditMode}
        >
          Back
        </button>
        {applicationType === "GPO" && (
          <button
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#contract-grid-modal"
            disabled={isPreviewSubmitting || isPacketSubmitting || isEditMode}
          >
            Contracts List
          </button>
        )}
        {applicationType === "GPO" && (
          <ContractFormModal
            id={id}
            isReadOnly={memberApplication.isReadOnly}
            onSave={(contracts) => setHasContacts(contracts !== "")}
          />
        )}
        {(!envelopeId || envelopeId ===
        "00000000-0000-0000-0000-000000000000") ? (
          <button
            id="send"
            className="btn btn-primary"
            // disabled={
            //   memberApplication.isReadOnly ||
            //   isPreviewSubmitting ||
            //   isPacketSubmitting ||
            //   isEditMode ||
            //   (applicationType === "GPO" && !hasContracts)
            // }
            type="button"
            onClick={onSubmit}
            disabled = {isPacketSubmitting || memberApplication.docusignId}
          >
            {isPacketSubmitting ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Submitting...
              </>
            ) : memberApplication.docusignId ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Processing Packet...
              </>
            ) : (
              <>Submit Packet</>
            )}
          </button>
        ) : (
          <button
            className="btn btn-primary"
            onClick={getPdf}
            disabled={isPacketSubmitting}
          >
            {isPacketSubmitting ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Loading...
              </>
            ) : (
              <>View Packet</>
            )}
          </button>
        )}

        <span className="btn-group">
          <button
            onClick={fetchExistingPreview}
            // disabled={
            //   memberApplication.isReadOnly ||
            //   isPreviewSubmitting ||
            //   isPacketSubmitting ||
            //   isEditMode ||
            //   (applicationType === "GPO" && !hasContracts) ||
            //   !hasExistingDocusignPreview
            // }
            className="btn btn-secondary"
          >
            {hasExistingDocusignPreview
              ? "Click Here to Preview"
              : "No Existing Preview"}
          </button>
          <button
            id="preview"
            className="btn btn-primary"
            // disabled={
            //   memberApplication.isReadOnly ||
            //   isPreviewSubmitting ||
            //   isPacketSubmitting ||
            //   isEditMode ||
            //   (applicationType === "GPO" && !hasContracts)
            // }
            type="button"
            onClick={onSubmit}
          >
            {isPreviewSubmitting ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Loading...
              </>
            ) : (
              <i
                id="preview-icon"
                className={`bi bi-${
                  hasExistingDocusignPreview
                    ? "arrow-clockwise"
                    : "plus-circle-fill"
                }`}
                title={
                  hasExistingDocusignPreview ? "Refresh Preview" : "Add Preview"
                }
              />
            )}
          </button>
         
        </span>

        { hasExistingDocusignPreview &&<button type="button" id="blank-packet" className="btn btn-primary" onClick={downloadBlankPacket} >
        {isBlankSubmitting ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Loading...
              </>
            ) : (<>Download Blank Packet</>)}
          </button>} 
      </div>
      <br />
      <input
          className="form-check-input"
          type="checkbox"
          disabled={memberApplication.isReadOnly}
          value=""
          onChange={onBlankPacketChange}
          id="BlankPacket"
          checked={blankPacket}
          name="BlankPacket"
        />
        <label
          className="form-check-label"
          htmlFor="BlankPacket"
        >
          Blank Packet
        </label>
        <br />
    </div>
  );
};

export default CreatePacketForm;
